<script setup lang="ts">
import type { IdRef } from './injection';

const props = defineProps<{
    idRef?: IdRef;
}>();

</script>
<template>
    <div
        class="tab-pane active"
        role="tabpanel"
        :aria-labelledby="props.idRef?.btnid"
        data-auto-tab-pane
    >
        <div class="panel panel-default rounded-3 bg-body-secondary border border-1 border-primary">
            <div class="panel-body">
                <slot />
            </div>
        </div>
    </div>
</template>
